import * as React from 'react';
import Button from '@material-ui/core/Button';
import SearchIcon from '@mui/icons-material/Search';

function EmptyScreeners() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Screeners</strong></p>
        <div>
          <Button
            href="/screener"
            size="small"
            variant="outlined"
            startIcon={<SearchIcon />}
          >
            Create a screener
          </Button>
        </div>
      </p>
    </div>
  );
}

export default EmptyScreeners;
